export default class MoreGamesController {

  constructor(app, pageId) {
    this.app = app;
    this.pageId = pageId;
  }
  show(path) {
    const app = this.app;
    const pageId = this.pageId || path;

    //get model
    const model = this.getModel();

    app.populate(pageId, model);
    app.swapPage(pageId);
  }
  getModel() {
    const app = this.app;
    const items = app.marketPlace.getGames();

    let model = items;
    return model;
  }

}